import { render, staticRenderFns } from "./ChatPrefixedInput.vue?vue&type=template&id=0b40db4c&scoped=true&"
import script from "./ChatPrefixedInput.vue?vue&type=script&lang=ts&"
export * from "./ChatPrefixedInput.vue?vue&type=script&lang=ts&"
import style0 from "./ChatPrefixedInput.vue?vue&type=style&index=0&id=0b40db4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b40db4c",
  null
  
)

export default component.exports